import { marked } from "marked";

export const SKILL_MARKDOWN_MARKED_OPTIONS = {
  gfm: true,
  breaks: false,
} as const;

export const parseSkillMarkdownToHtml = (text: string): string =>
  marked.parse(text, SKILL_MARKDOWN_MARKED_OPTIONS) as string;
